import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import posthog from "posthog-js";

export default function PostHogPageview() {
  const location = useLocation();

  useEffect(() => {
    if (!posthog?.__loaded) return;
    const url = location.pathname + location.search + location.hash;
    posthog.capture("$pageview", { $current_url: url });
  }, [location]);

  return null;
}
